import {HttpContextToken} from '@angular/common/http';

// Multipart upload control requests need the original HTTP status to retry
// transient failures. Authentication failures retain the global handling.
export const HANDLE_UPLOAD_ERRORS = new HttpContextToken<boolean>(() => false);
